import mixin from './../mixin';
import TableFilterable from './filterable';
import TableDeleteMultipleRowsMixin from './delete_multiple_rows_mixin';
import TableProcessDeleteTableRowResultMixin from './process_delete_table_row_result_mixin';

class TableFilterableMultipleDeletable extends TableFilterable {

  init() {
    super.init();
    this._initDeleteSelectedRowsButton();
  }

  _initTableLinks() {
    super._initTableLinks();
    this._initSelectAllCheckbox();
  }

  _submitSelectedCheckboxesForm(form, url) {

    var table = this;

    $.ajax({
      url: table._addFilterUrlArgs(url),
      type: 'post',
      dataType: 'json',
      data: $(form).serialize(),
      beforeSend: table.showLoadingBlock.bind(table),
      complete: table.hideLoadingBlock.bind(table),
      success: table._processDeleteTableRowResult.bind(table)
    });
  }

  _resetViewAfterTableRowDeletion() {
    this._resetStatusMessages();
  }
};

mixin(TableFilterableMultipleDeletable, TableDeleteMultipleRowsMixin);
mixin(TableFilterableMultipleDeletable, TableProcessDeleteTableRowResultMixin);

export default TableFilterableMultipleDeletable;


/** WEBPACK FOOTER **
 ** ./src/common/table/filterable_multiple_deletable.js
 **/